export default "__VITE_ASSET__408f71bd__"